/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ward: NonNullable<unknown> }} Carrier_Legacy_Address_Ward_MoveInputs */

const vi_carrier_legacy_address_ward_move = /** @type {(inputs: Carrier_Legacy_Address_Ward_MoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đổi sang ${i?.ward}`)
};

/**

* @param {Carrier_Legacy_Address_Ward_MoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_address_ward_move = /** @type {((inputs: Carrier_Legacy_Address_Ward_MoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Address_Ward_MoveInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_address_ward_move(inputs)
});